import { useLocation, Navigate, Outlet } from 'react-router-dom';

import { getAllRoles, getCurrentRole } from 'src/constants';
import DashboardContainer from 'src/Containers/DashboardContainer';

interface RequireAuthProps {
  allowedRoles: string[];
}

type LocationProps = {
  state: {
    from: Location;
  };
};

const RequireAuth = ({ allowedRoles }: RequireAuthProps) => {
  const profileDetails = JSON.parse(localStorage.getItem('profile') as string);
  const location = useLocation() as unknown as LocationProps;

  const role = getCurrentRole(getAllRoles(profileDetails));

  return allowedRoles?.includes(role as any) ? (
    <DashboardContainer>
      <Outlet />
    </DashboardContainer>
  ) : profileDetails ? (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireAuth;
